import { useQuery } from "@tanstack/react-query";
import { createApiClient } from "@floline/api-client";
import { API_URL } from "@/env";

const apiClient = createApiClient(API_URL);

export const locationSearchKeys = {
  all: ["location-search"] as const,
  query: (query: string) => [...locationSearchKeys.all, query.toLowerCase()] as const,
};

export interface UseLocationSearchOptions {
  enabled?: boolean;
  minQueryLength?: number;
}

export function useLocationSearch(query: string, options: UseLocationSearchOptions = {}) {
  const { enabled = true, minQueryLength = 2 } = options;
  const normalizedQuery = query.trim();
  const shouldSearch = enabled && normalizedQuery.length >= minQueryLength;

  const queryResult = useQuery({
    queryKey: locationSearchKeys.query(normalizedQuery),
    queryFn: async () => {
      const response = await apiClient.searchLocations(normalizedQuery);
      return response.data;
    },
    enabled: shouldSearch,
    staleTime: 60 * 1000,
  });

  return {
    results: queryResult.data ?? [],
    isLoading: queryResult.isLoading,
    isFetching: queryResult.isFetching,
    isError: queryResult.isError,
    error: queryResult.error,
  };
}
